const newsTeaserSmall = document.querySelectorAll(".news-teaser-small-item");

if (newsTeaserSmall) {
    newsTeaserSmall.forEach((item) => {
        const textContentContainer = item.querySelector(".news-teaser-small__text-content");
        const textContentElement = textContentContainer?.firstElementChild || null;
        const maxTextLength = 100;

        if (!textContentElement || textContentElement === null) return;

        if (textContentContainer.childElementCount > 1) {
            textContentContainer.innerHTML = "";
            textContentContainer.appendChild(textContentElement);
        }

        if (textContentElement && textContentElement.textContent.length > maxTextLength) {
            const lastWordEnd = textContentElement.textContent.substr(0, maxTextLength).lastIndexOf(" ");
            textContentElement.textContent = textContentElement.textContent.substr(0, lastWordEnd) + "...";
        }
    });
}
